// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip_Tooltip__RTiVD","black":"Tooltip_black__3ZCE7","yellow":"Tooltip_yellow__2WMgF","white":"Tooltip_white__gHY0d","pinnedPanel":"Tooltip_pinnedPanel__35APf"};